/**
 * Macro segment colors for doughnut / pie charts.
 * Keep in sync with recipe nutrition UI (`NutritionTotals` macro donut + legend).
 */
export const MACRO_CHART_COLORS = {
  carbs: '#60C6D9',
  protein: '#3B82F6',
  fat: '#6366F1',
  fiber: '#F59E0B',
  /** Fourth macro-energy slot when using carb/protein/fat/alcohol (7 kcal/g). */
  alcohol: '#EC4899',
} as const;
